import {
  useInitializeOfflineMode,
  useAuth,
  useInitializeOfflineData
} from "duck";
import { useLoginMutation } from "requests";
import { FormValues } from "./types";

export const useLogin = () => {
  const [, setAuth] = useAuth();
  const [login] = useLoginMutation();

  const initOffline = useInitializeOfflineMode();
  const { initOfflineData } = useInitializeOfflineData();

  return (values: FormValues) =>
    login({
      variables: { username: values.username, password: values.password }
    }).then(response => {
      const auth = response.data?.createAuthentication?.authentication;
      if (!auth) {
        return;
      }

      const { sessionId, applicationSettings } = auth;
      localStorage.setItem("sessionId", sessionId);
      setAuth({ loading: false, user: applicationSettings.user });
      initOffline(applicationSettings.user);
      initOfflineData(applicationSettings.user.organization?._id);
    });
};
